/**
 * Shared bread calculations utilities
 */

import { BREAD } from '../../constants/uiConstants';

/**
 * Calculate lifetime total bread slices for a player
 * @param {Object} playerStats - Player stats object from calculatePlayerStats
 * @returns {number} Total slice value (full = 1.0, half = 0.5)
 */
export const calculateLifetimeTotal = playerStats => {
  if (!playerStats) return 0;

  const fullSlices = playerStats.lifetimeFullSlices || 0;
  const halfSlices = playerStats.lifetimeHalfSlices || 0;

  return (
    fullSlices * BREAD.FULL_SLICE_VALUE + halfSlices * BREAD.HALF_SLICE_VALUE
  );
};

/**
 * Calculate outstanding debt for a player
 * @param {Object} playerStats - Player stats object from calculatePlayerStats
 * @returns {Object} Outstanding full and half slices
 */
export const calculateOutstandingDebt = playerStats => {
  if (!playerStats) return { fullSlices: 0, halfSlices: 0, total: 0 };

  const outstandingFull = Math.max(
    0,
    (playerStats.earnedFullSlices || 0) - (playerStats.paidFullSlices || 0)
  );
  const outstandingHalf = Math.max(
    0,
    (playerStats.earnedHalfSlices || 0) - (playerStats.paidHalfSlices || 0)
  );
  const total =
    outstandingFull * BREAD.FULL_SLICE_VALUE +
    outstandingHalf * BREAD.HALF_SLICE_VALUE;

  return {
    fullSlices: outstandingFull,
    halfSlices: outstandingHalf,
    total,
  };
};

/**
 * Calculate debt rank value for sorting
 * @param {Object} playerStats - Player stats object
 * @returns {number} Debt rank value
 */
export const calculateDebtRank = playerStats => {
  if (!playerStats) return 0;

  const netFull = playerStats.earnedFullSlices - playerStats.paidFullSlices;
  const netHalf = playerStats.earnedHalfSlices - playerStats.paidHalfSlices;

  return netFull * BREAD.FULL_SLICE_MULTIPLIER + netHalf;
};
